export function initShareButtons() {
    /** @type {NodeListOf<HTMLButtonElement>} */
    const shareBtns = document.querySelectorAll('.button--share');
    for (const btn of shareBtns) {
        btn.addEventListener('click', async () => {
            await navigator.share({
                title: btn.dataset.shareTitle,
                url: btn.dataset.shareUrl,
                text: btn.dataset.shareText ?? '',
            });
        });
    }
}